import {ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {animate, keyframes, style, transition, trigger} from "@angular/animations";
import {BuilderSectionsInteractionService} from "../../../../../../builder-sections-interaction.service";
import {VibeCodingFlowService} from "../../../../../../../shared/services/vibe-coding-flow.service";
import {Website} from "../../../../../../../websites/website/website";

@Component({
    selector: 'db-site-info-sidebar',
    templateUrl: './site-info-sidebar.component.html',
    styleUrl: './site-info-sidebar.component.scss',
    animations: [
        trigger('fadeSlideAnimation', [
            // Slide In + Fade In
            transition(':enter', [
                style({ opacity: 0, transform: 'translateX(100%)' }), // Start off-screen and invisible
                animate('400ms ease', // Total duration for the animation
                keyframes([
                    style({ opacity: 0, transform: 'translateX(100%)', offset: 0 }), // Start with no opacity change
                    style({ opacity: 0, transform: 'translateX(50%)', offset: 0.4 }), // Slide halfway with no opacity change
                    style({ opacity: 0, transform: 'translateX(25%)', offset: 0.6 }), // Start fading in while still sliding
                    style({ opacity: 0, transform: 'translateX(15%)', offset: 0.8 }), // Start fading in while still sliding
                    style({ opacity: 0.3, transform: 'translateX(2%)', offset: 0.9 }), // Start fading in while still sliding
                    style({ opacity: 1, transform: 'translateX(0)', offset: 1 }) // Fully fade in and slide into position
                ]))
            ]),
            // Fade Out + Slide Out
            transition(':leave', [
                animate('400ms ease', keyframes([
                    style({ opacity: 1, transform: 'translateX(0)', offset: 0 }), // Start fully visible
                    // style({ opacity: 0.1, transform: 'translateX(0)', offset: 0.8 }), // Fade out to almost invisible (no movement yet)
                    style({ opacity: 0, offset: 1 }) // Fully fade out and slide off-screen
                ]))
            ])
        ]),
        trigger('fadeSlideLeftAnimation', [
            // Slide In + Fade In
            transition(':enter', [
                style({ opacity: 0, transform: 'translateX(100%)' }), // Start off-screen and invisible
                animate('400ms ease', // Total duration for the animation
                keyframes([
                    style({ opacity: 0, transform: 'translateX(-100%)', offset: 0 }), // Start with no opacity change
                    style({ opacity: 0, transform: 'translateX(-50%)', offset: 0.4 }), // Slide halfway with no opacity change
                    style({ opacity: 0, transform: 'translateX(-25%)', offset: 0.6 }), // Start fading in while still sliding
                    style({ opacity: 0, transform: 'translateX(-15%)', offset: 0.8 }), // Start fading in while still sliding
                    style({ opacity: 0.3, transform: 'translateX(-2%)', offset: 0.9 }), // Start fading in while still sliding
                    style({ opacity: 1, transform: 'translateX(0)', offset: 1 }) // Fully fade in and slide into position
                ]))
            ]),
            // Fade Out + Slide Out
            transition(':leave', [
                animate('400ms ease', keyframes([
                    style({ opacity: 1, transform: 'translateX(0)', offset: 0 }), // Start fully visible
                    // style({ opacity: 0.1, transform: 'translateX(0)', offset: 0.8 }), // Fade out to almost invisible (no movement yet)
                    style({ opacity: 0, offset: 1 }) // Fully fade out and slide off-screen
                ]))
            ])
        ])
    ],
    standalone: false
})
export class SiteInfoSidebarComponent {
  isEditingDescription;
  isComponentVisible: boolean = true;
  @Input() website: Website;
  @Output() onEvent: EventEmitter<{
    eventCategory: string,
    eventAction: string,
    eventLabel: string,
  }> = new EventEmitter<{
    eventCategory: string,
    eventAction: string,
    eventLabel: string,
  }>();

  constructor(private _cdr: ChangeDetectorRef,
              public builderInteractionsService: BuilderSectionsInteractionService,
              private _vibeCodingFlowService: VibeCodingFlowService) {
  }

  onOpenDescription() {
    // this.isEditingDescription = true;
    // return;
    this.isComponentVisible = false;
    const vibeCodingFlow = this._vibeCodingFlowService.isVibeCodingFlow();

    setTimeout(() => {
      this.isEditingDescription = true;
      this.isComponentVisible = true; // Show new component after fade-out
      this.onEvent.emit({
        eventCategory: 'Onboarding',
        eventAction: (vibeCodingFlow ? 'Vibe-coding AI Flow' : 'Section-based AI Flow') + ' - Description - Show More',
        eventLabel: '-',
      });
      this._cdr.detectChanges();
    }, 450); // Matches fade-out duration
  }

  onCloseDescription() {
    // this.isEditingDescription = false;
    // return;
    this.isComponentVisible = false;
    setTimeout(() => {
      this.isEditingDescription = false;
      this.isComponentVisible = true; // Show new component after fade-out
      this._cdr.detectChanges();
    }, 350); // Matches fade-out duration
  }
}
